<app-dialog-base [Title]='title |translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="searchbox">
    <app-group-filter *ngIf="groups.length > 0" [groups]="groups" [isEditable]="false"
                      (onSelectGroup)="selectGroup($event)">
    </app-group-filter>
    <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}"
            (input)="onTermChange($event)" />
  </div>
  <div class="tablewrap admindrivers">
    <div class="loading-overlay" *ngIf="isLoading">
      <div class="spinningCircle"></div>
      <div class="loading-label">{{'Loading...' | translate}}</div>
    </div>
    <div class="table">
      <table fixedcols="[0]">
        <tr>
          <th>
            <switch-all-checkbox [items]="objects | groupFilter : filter" *ngIf="!isSingleItem"/>
          </th>
          <th>{{'Name'|translate }}</th>
          <th *ngIf="companyLookup">{{'Company'|translate }}</th>
        </tr>
        <tr *ngFor="let object of objects | groupFilter : filter">
          <td>
            <input *ngIf="object.CanSelect !== false" type="checkbox" [(ngModel)]="object.IsChecked" (change)="onToggle(object)" />
          </td>
          <td>{{object.Name}}</td>
          <td *ngIf="companyLookup">{{companyLookup[object.CompanyId] || ''}}</td>
        </tr>
      </table>
    </div>
  </div>
</app-dialog-base>
